import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Plus, X, Users, Building2, ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";

const FloatingPostButton = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Hide on admin/worker pages
  if (["/admin", "/worker-login", "/worker-dashboard"].includes(location.pathname)) return null;

  const options = [
    { label: "Register as Worker", icon: Users, href: "/hire-workers#register", color: "bg-marigold text-indigo" },
    { label: "List Property", icon: Building2, href: "/real-estate#post", color: "bg-sage text-white" },
    { label: "Sell an Item", icon: ShoppingBag, href: "/marketplace#post", color: "bg-terracotta text-white" },
  ];

  return (
    <div className="fixed bottom-6 left-6 z-50" data-testid="floating-post-button">
      {open && (
        <div className="mb-3 flex flex-col gap-2 items-start animate-fade-in-up">
          {options.map((opt) => {
            const Icon = opt.icon;
            return (
              <button
                key={opt.label}
                onClick={() => { setOpen(false); window.location.href = opt.href; }}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium shadow-lg ${opt.color} hover:shadow-xl transition-all`}
                data-testid={`post-option-${opt.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <Icon size={16} />{opt.label}
              </button>
            );
          })}
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className={`w-14 h-14 rounded-full shadow-xl flex items-center justify-center transition-all duration-200 ${open ? 'bg-gray-800 rotate-45' : 'bg-indigo hover:bg-indigo/90'}`}
        data-testid="floating-post-trigger"
      >
        {open ? <X size={22} className="text-white" /> : <Plus size={22} className="text-white" />}
      </button>
    </div>
  );
};

export default FloatingPostButton;
